export const DIMENSION_KEYS = [
  'cats',
  'dogs',
  'kids',
  'energy',
  'affection',
  'newPeople',
  'housemanners',
] as const;

export type DimensionKey = (typeof DIMENSION_KEYS)[number];

export type QuestionDimension = {
  key: DimensionKey;
  title: string;
  /** Likert level 1–5 → full answer text from CSV */
  levels: Record<number, string>;
};

export type ShelterAttribute = {
  'Internal-ID': string;
  AttributeName: string;
  Publish: string;
};

export type ShelterAnimal = {
  ID: string;
  Name: string;
  Type: string;
  Sex: string;
  Breed: string;
  CoverPhoto: string;
  /** External adoption / profile site (http(s)); omitted when unset. */
  ProfileUrl?: string;
  Attributes: ShelterAttribute[];
};

export type ShelterExport = {
  success: number;
  animals: ShelterAnimal[];
};

export type RankedAnimal = {
  animal: ShelterAnimal;
  /** Importance-weighted sum of squared level errors (lower = better). */
  weightedPenalty: number;
  /** 0–100, higher = closer match under current importance weights. */
  matchPercent: number;
};
